<template>
  <div class="payment-feedback">
    <div v-if="isSuccess" class="status-card success">
      <div class="header">
        <span class="icon">✅</span>
        <h1>{{ t('paymentSuccess.paymentSuccess') }}</h1>
      </div>
      <div class="body">
        <p>{{ t('paymentSuccess.orderNumber') }}：{{ orderId }}</p>
        <p>{{ t('paymentSuccess.thankYou') }}</p>
      </div>
      <button @click="next" class="btn btn-primary">{{ t('paymentSuccess.continueShopping') }}</button>
      <!-- <router-link to="/shop" class="btn">回商店繼續逛</router-link> -->
    </div>

    <div v-else class="status-card failure">
      <div class="header">
        <span class="icon">❌</span>
        <h1>{{ t('paymentSuccess.transactionFailed') }}</h1>
      </div>
      <div class="body">
        <p>{{ t('paymentSuccess.orderNumber') }}：{{ orderId }}</p>
        <p class="error-detail">{{ errorMsg }}</p>
      </div>
      <div class="actions">
        <button @click="next" class="btn btn-primary">{{ t('paymentSuccess.retry') }}</button>
        <router-link to="/support" class="btn btn-text">{{ t('paymentSuccess.contactSupport') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

// 判斷是否成功的邏輯
const qr = computed(() => route.query.qr );
const isSuccess = computed(() => route.query.pay_res === '1');
const orderId = computed(() => route.query.order_id || '未知');
const errorMsg = computed(() => route.query.em || t('paymentSuccess.errorDetail'));

const retry = () => router.push('/checkout');
const next = () => router.push(`/menu_order/${qr.value}`);
</script>